import React from 'react'
import logo from '../../../assets/images/atlas_logo.svg'
import UserProfile from '../userProfile/UserProfile'
import { getEnvName } from '../../../utils/UICommonFunction'

const ATNavBar = () => {
  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex align-items-center">
        <img alt="Logo" width={128} height={50} src={logo}></img>
        <span className="text-danger h2 mx-1 my-1 env">{getEnvName()}</span>
      </div>

      <div className="d-flex justify-content-end">
        <div className="pt-2 px-2">
          <UserProfile />
        </div>
      </div>
    </div>
  )
}

export default ATNavBar
